export class UnassignRequest {
  public userName: string;
  public businessId: number;
  public subscriptionId: number
  public ticketNumber: string
  public businessName: string
  public reason: string
}
